import axios from "axios";

export { modelCarActions };

axios.defaults.withCredentials = true;

function modelCarActions() {
  const baseUrl = ``;
  const tenantVal = `${process.env.REACT_APP_TENANT}`;

  return {
    getModelQueryParams,
    exportDataModelCar,
  };

  async function exportDataModelCar(
    tenant: string,
    code?: string,
    description?: string,
    codeBrand?: string,
    descriptionBrand?: string
  ) {
    const exportAllDataModelCar = await axios.get(
      `${baseUrl}/masterdatavehicle/model/excel`,
      {
        params: {
          tenant:tenant,
          modelCode: code,
          modelDescription: description,
          brandDescription: descriptionBrand,
          brandCode: codeBrand,
        },
        responseType: "arraybuffer",
        headers: { "Access-Control-Allow-Origin": true },
     
      }
    );
    return exportAllDataModelCar;
  }

  async function getModelQueryParams(
    pageNumber: number,
    pageSize: number,
    tenant: string,
    code?: string,
    description?: string,
    codeBrand?: string,
    descriptionBrand?: string
  ) {
    const getAllModelQueryParams = await axios.get(
      `${baseUrl}/masterdatavehicle/model`,
      {
        params: {
          pageNumber: pageNumber,
          pageSize: pageSize,
          tenant:tenant,
          modelCode: code,
          modelDescription: description,
          brandDescription: descriptionBrand,
          brandCode: codeBrand,
        },
      }
    );

    return getAllModelQueryParams;
  }
}
